import { partnerImagesApi } from 'legacy/lut/classes/services/api/PartnerImagesApi'
import { read, save } from 'legacy/lut/store'
import { StoreForms } from 'legacy/lut/store/state'

import { HttpCancel } from 'core/classes/http'

class PartnerImagesStoreService {
  public getImages = async (partnerId: string, isForced = false, cancelObject?: HttpCancel) => {
    let result: any = !isForced
      ? read(StoreForms.partnerImages, `partner_pos_images_${partnerId}`)
      : null
    if (!result) {
      result = await partnerImagesApi.fetchPartnerImages(partnerId, cancelObject)
      save(StoreForms.partnerImages, `partner_pos_images_${partnerId}`, result)
    }
    return result.items
  }
}

export const partnerImagesStoreService = new PartnerImagesStoreService()
